<i
  [class]="'material-symbols-' + (matSymbol().style || defaultStyle)"
  [style.font-size.px]="matSymbol().size || defaultSizeInPx"
  [style.color]="matSymbol().color || ''"
  [style.transform]="
    matSymbol().rotationAngle && 'rotate(' + matSymbol().rotationAngle + 'deg)'
  "
  [style.font-variation-settings]="matSymbol().fill && '\'FILL\' 1'"
>
  {{ matSymbol().symbol }}
</i>
